<template>
  <div class="uploadData">
    <el-tabs class="upload-tabs" v-model="activeNameChildValue" type="card" @tab-click="handleClick">
      <el-tab-pane :label="item.versionNameSub" :name="index+''" v-for="(item, index) in subVersionList" :key="index+''">
        <el-table class="table-uploadData" :data="uploadStatus" border header-cell-class-name="headerStyle" cell-class-name="cellStyle">
          <el-table-column prop="dataName" label="数据表"></el-table-column>
          <el-table-column prop="uploadTime" label="最后上传时间"></el-table-column>
          <el-table-column prop="uploadUser" label="上传人"></el-table-column>
          <el-table-column prop="uploadStatus" label="状态">
            <!-- <template slot-scope="scope">
              <el-tag :type="scope.row.uploadStatus === '1' ? 'success' : 'info'" disable-transitions>{{scope.row.uploadState==='1' ? '上传成功' : '暂未上传'}}</el-tag>
            </template> -->
            <template slot-scope="scope">
              <template v-if="scope.row.uploadStatus==='1'">
                <i class="el-icon-success downloadIcon"></i>
                <span class="downloadIconText">上传成功</span>
              </template>
              <template v-else>
                <i class="el-icon-remove notUploadIcon"></i>
                <span>暂未上传</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="id" label="上传">
            <template slot-scope="scope">
              <el-upload :multiple='false'
              action
              :http-request="fileUpload"
              :data={id:scope.row.id,dataId:scope.row.dataId,dataCode:scope.row.dataCode,versionName:scope.row.versionName,versionNameSub:scope.row.versionNameSub}
              :show-file-list='false'
              :before-upload="beforeUpload">
                <i class="el-icon-upload2 downloadIcon"></i>
              </el-upload>
            </template>
          </el-table-column>
          <el-table-column label="下载">
            <template slot-scope="scope">
              <template v-if="scope.row.uploadStatus==='1'">
                <i class="el-icon-download downloadIcon" @click="downloadExcel(scope.row)"></i>
              </template>
              <template v-else>
                <i class="el-icon-download downloadIcon"></i>
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'uploadData',
  props: ['activeNameChild'],
  data () {
    return {
      activeNameChildValue: '',
      subVersionList: [], // 季度列表
      uploadStatus: [] // 上传数据列表
    }
  },
  watch: {
    // 监听tabs-index值改变
    activeNameChild (newValue, oldValue) {
      this.activeNameChildValue = newValue
    }
  },
  created () {},
  mounted () {},
  methods: {
    // 季度列表--2021-医院
    getQuarterBonusList (versionName) {
      this.subVersionList = []
      this.$http
        .get(this.API.versionInfoSub, {
          params: {
            pVersionName: versionName
          }
        })
        .then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.subVersionList = data.data
            // 调用数据上传状态列表--2021-医院-Q1
            this.getUploadStatus(data.data[0].versionNameSub)
          } else {
            this.$message.error('接口调用失败！')
          }
        })
    },
    // 获取数据上传状态列表--2021-医院-Q1
    getUploadStatus (versionNameSub) {
      this.uploadStatus = []
      this.$http
        .get(this.API.uploadDataVersionInfoSubList, {
          params: {
            versionName: versionNameSub
          }
        })
        .then((res) => {
          let data = res.data
          if (data.code === 200) {
            this.uploadStatus = data.data
          } else {
            this.$message.error('接口调用失败！')
          }
        })
    },
    // 切换上传状态
    handleClick (tab, event) {
      // console.log(tab)
      this.$emit('activeNameChildChange', tab.name)
      // 调用上传状态列表--2021-医院-Q1
      this.getUploadStatus(tab.label)
    },
    // 上传前校验
    beforeUpload (file) {
      // console.log(file)
      // file.name-文件名字
      // file.size-文件大小
      // file.type-文件类型
      // 上传前格式与大小校验
      const isExcel = file.type === 'application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      // const isLt2M = file.size / 1024 / 1024 < 2
      if (!isExcel) {
        this.$message.error('上传模板只能是Excel格式!')
      }
      // if (!isLt2M) {
      //   this.$message.error('上传模板大小不能超过 2MB!')
      // }
      // return isJPG && isLt2M
      return isExcel
    },
    // 上传模板
    fileUpload (e) {
      // console.log(e)
      let formData = new FormData()
      formData.append('id', e.data.id)
      formData.append('dataId', e.data.dataId)
      formData.append('dataCode', e.data.dataCode)
      formData.append('versionName', e.data.versionName)
      formData.append('versionNameSub', e.data.versionNameSub)
      formData.append('file', e.file)
      this.$http.post(this.API.incentiveDataMappingUpload, formData, { headers: { 'Content-Type': 'multipart/form-data' } }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          if (data.code === 200) {
            this.$message.success('模板上传成功！')
            this.getUploadStatus(data.data)
          } else {
            this.$message.error(data.msg + ' --- 请重新上传模板！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 下载
    downloadExcel (e) {
      this.$http.get(this.API.incentiveDataMappingExport, { params: { id: e.id, versionName: e.versionNameSub, dataCode: e.dataCode }, responseType: 'blob' }).then(res => {
        // console.log(res)
        if (res.status === 200) {
          let data = res.data
          // console.log(res.data.code)
          if (data.code === 500) {
            this.$message.error(data.msg)
          } else {
            let blob = new Blob([data], { type: data.type })
            let downloadElement = document.createElement('a')
            let href = window.URL.createObjectURL(blob) // 创建下载的链接
            downloadElement.href = href
            downloadElement.download = e.versionNameSub + '-' + e.dataName + '.xls' // 下载后文件名
            document.body.appendChild(downloadElement) // 添加元素
            downloadElement.click() // 点击下载
            document.body.removeChild(downloadElement) // 下载完成移除元素
            window.URL.revokeObjectURL(href) // 释放掉blob对象
            this.$message.success('下载成功！')
          }
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.uploadData {
  // Tabs 标签页-覆盖
  .upload-tabs {
    /deep/.el-tabs__item {
      border: none !important;
      border-right: 1px solid #eee !important;
    }
    /deep/.el-tabs__active-bar {
      height: 2px !important;
    }
    /deep/.el-tabs__item.is-active {
      background-color: #fff !important;
      color: #409eff !important;
      border-bottom-color: #fff;
    }
    /deep/.el-tabs__item.is-top:nth-child(2) {
      border-left: 1px solid #eee;
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
      padding-left: 20px !important;
    }
    /deep/.el-tabs__item.is-top:last-child {
      border-top-right-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      padding-right: 20px !important;
      border-right: none !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      height: 2px !important;
    }
    /deep/.el-tabs__nav-scroll {
      text-align: left !important;
    }
    /deep/.el-tabs__nav {
      float: left !important;
    }
  }
}
</style>
